<template>
  <el-select :value="value" :placeholder="placeholder" @change="onChange" :size="size" clearable :disabled="disabled">
      <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.value">
      </el-option>
  </el-select>
</template>

<script>
import Vue from 'vue'
import config from '@/config'

export default {
  name: 'ElDictionary',

  created() {
    Vue.http.get(config.api.url + '/dictionaryItems/' + this.code).then(res => {
      this.options = res.data
    })
  },
  data () {
    return {
      options: []
    }
  },

  props: {
    code: [String],
    size: [String],
    disabled: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Array,
      default: () => []
    },
    value: [String, Number],
    placeholder: [String]
  },
  methods: {
    onChange (v) {
      this.$emit('input', v)
      this.$emit('change', v)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dictionary.vue